module.exports = __webpack_public_path__ + "static/media/salaries-argentina.99983756.png";